import { render } from "./IOPObstetricalHistoryForm.vue?vue&type=template&id=22f54f23"
import script from "./IOPObstetricalHistoryForm.vue?vue&type=script&lang=js"
export * from "./IOPObstetricalHistoryForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__